import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

export type AgentJobStatus =
  | "PENDING"
  | "RUNNING"
  | "WAITING_APPROVAL"
  | "COMPLETED"
  | "FAILED";

export interface AgentJob {
  id: string;
  brandId: string;
  projectId: string | null;
  type: string;
  status: AgentJobStatus;
  payload: Record<string, unknown> | null;
  result: Record<string, unknown> | null;
  error: string | null;
  createdAt: string;
  completedAt: string | null;
}

const TERMINAL: AgentJobStatus[] = ["COMPLETED", "FAILED"];

/**
 * Poll an AgentJob every 2s until it reaches a terminal status.
 * Pass jobId=null to disable (e.g. before a generation kicks off).
 */
export function useAgentJob(brandId: string, jobId: string | null) {
  return useQuery({
    queryKey: ["agentJob", brandId, jobId],
    queryFn: () => apiFetch<AgentJob>(`/brands/${brandId}/agent-jobs/${jobId}`),
    enabled: !!brandId && !!jobId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status && TERMINAL.includes(status) ? false : 2000;
    },
  });
}
